import _get from 'lodash.get';
import MSP_CONFIG, { HOTPICKS_CONFIG } from 'constants_msp/index';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { REVIEWS_STAG_DOMAIN, REVIEWS_LIVE_DOMAIN } from '../../../constants';

const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

const compareCaseInsensitive = (str1 = '', str2 = '') =>
  str1.toUpperCase() === str2.toUpperCase();

export const isOrganicArticle = () => {
  const referrer = _get(
    typeof window !== 'undefined' ? window : {},
    'document.referrer',
    '',
  );
  return referrer.includes('google') || referrer.includes('ampproject');
};

export const getPaidReferrer = () => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    if (
      searchParams.get('utm_source') === 'Google' &&
      searchParams.get('utm_medium') === 'PaidSearch'
    ) {
      return 'paid_traffic';
    }
  }
  return '';
};

export const handleMSPOrganicTag = strWithTag => {
  if (strWithTag.includes('toi_hotpicks')) {
    return strWithTag.replace(/hotpicks_/gi, 'hotpicks_org_');
  }

  return strWithTag.replace(/bestproducts_/gi, 'bestproducts_org_');
};
// AF-417 : handle organic traffic based tags

export const handleMSPPaidTrafficTag = strWithTag => {
  if (strWithTag.includes('toi_hotpicks')) {
    return strWithTag.replace(/hotpicks_/gi, 'hotpicks__pd_');
  }
  return strWithTag.replace(/bestproducts_/gi, 'bestproducts_pd_');
};
// AF-417 : handle organic traffic based tags

export const convertCDataAnchorTagsForOrganic = ignoreOrgHandling => {
  document
    .querySelectorAll('[data-msp_table_anchor], [data-msp_anchor]')
    .forEach(linkEl => {
      if (ignoreOrgHandling) {
        linkEl.setAttribute('data-org-tag-handled', 'yes');
      } else if (linkEl.getAttribute('data-org-tag-handled') !== 'yes') {
        linkEl.setAttribute(
          'href',
          handleMSPOrganicTag(linkEl.getAttribute('href')),
        );
        linkEl.setAttribute('data-org-tag-handled', 'yes');
      }
    });
};

export const convertCDataAnchorTagsForPaidTraffic = ignoreOrgHandling => {
  document
    .querySelectorAll('[data-msp_table_anchor], [data-msp_anchor]')
    .forEach(linkEl => {
      if (ignoreOrgHandling) {
        linkEl.setAttribute('data-paid-traffic-tag-handled', 'yes');
      } else if (
        linkEl.getAttribute('data-paid-traffic-tag-handled') !== 'yes'
      ) {
        linkEl.setAttribute(
          'href',
          handleMSPPaidTrafficTag(linkEl.getAttribute('href')),
        );
        linkEl.setAttribute('data-paid-traffic-tag-handled', 'yes');
      }
    });
};

export const getURLwithTag = (url = '', tag = '', isOrganic, isPaidTraffic) => {
  let finalTag = isOrganic ? handleMSPOrganicTag(tag) : tag;
  if (isPaidTraffic) {
    finalTag = handleMSPPaidTrafficTag(tag);
  }
  return finalTag
    ? `${url}${url.includes('?') ? '&' : '?'}tag=${finalTag}`
    : url;
};

export const getMSPGA = (
  platfrom,
  label = '',
  affiliateName = '',
  format = '',
) => {
  let gaSource = MSP_CONFIG.GA[platfrom];
  if (typeof window !== 'undefined') {
    const { location: { href = '' } = {} } = window;
    if (href.includes('hot-picks')) {
      gaSource = HOTPICKS_CONFIG.GA[platfrom];
    }
  }
  const { category: gaCategory, action } = gaSource;
  let category = gaCategory;
  let updateAction = false;
  let updateLabel = false;
  if (
    !compareCaseInsensitive(affiliateName, 'AMAZON') &&
    !compareCaseInsensitive(affiliateName, 'TATACLIQ')
  ) {
    updateAction = true;
    updateLabel = true;
  }
  if (typeof window !== 'undefined' && window.isMspUSPage) {
    category += '_US';
  }

  const capAffName = capitalizeFirstLetter(affiliateName);

  const finalAction = updateAction
    ? action.replace('Affiliate', capAffName)
    : action;

  const finalLabel = updateLabel ? `${capAffName}_${label}` : label;
  return format === 'object'
    ? {
        category,
        action: finalAction,
        label: finalLabel,
      }
    : `${category}|${finalAction}|${finalLabel}`;
};

export const addMspGaTrigger = () => {
  document.addEventListener('click', e => {
    const { target: { dataset, innerText = '' } = {} } = e;
    const { affiliateName = '' } = dataset;
    if (
      dataset.msp_anchor_strong ||
      dataset.msp_table_anchor ||
      dataset.msp_anchor
    ) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'affiliate_hyperlink',
        label: `${affiliateName}_${innerText}`,
        category: 'table_link',
      });
    }
  });
};

export const getAmazonLogoByCountry = () => {
  if (typeof window !== 'undefined') {
    const { CountryCode = '' } = window.geoinfo || {};
    if (CountryCode.toLowerCase() === 'in') {
      return 'https://static.toiimg.com/thumb/height-30,resizemode-4,msid-104038499/104038499.jpg';
    }
  }
  return undefined;
};

export const getMspInPageHrefLang = (
  context,
  hreflang,
  mspHrefLangUrl = {},
) => {
  const { isArticlePageURL, url } = mspHrefLangUrl;
  const domain = 'https://timesofindia.indiatimes.com';
  if (isArticlePageURL) {
    hreflang.push(
      {
        lang: 'en-in',
        url: `${domain}${context.pathname}`,
      },

      {
        lang: 'en-us',
        url,
      },
    );
  }
};

export const getMspBasicPageHrefLang = (context, hreflang, CountryCode) => {
  hreflang.push({
    lang: `en-${CountryCode.toLowerCase()}`,
    url: `https://timesofindia.indiatimes.com${context.pathname}`,
  });
};

export const getMSPCountryCodeMap = () => ({
  '105993091': 'AE',
  '107074949': 'SA',
});

export const getMspUSPageHrefLang = (
  context,
  hreflang,
  mspHrefLangUrl = {},
) => {
  const { isArticlePageURL, url } = mspHrefLangUrl;
  hreflang.push({
    lang: 'en-us',
    url: `https://timesofindia.indiatimes.com${context.pathname}`,
  });

  if (isArticlePageURL) {
    hreflang.push({
      lang: 'en-in',
      url,
    });
  }
};

export const getKeyword = (keyword = '') => {
  if (typeof window !== 'undefined') {
    const { location: { search = '' } = {} } = window;
    const searchParams = new URLSearchParams(search);
    if (
      searchParams.get('utm_source') === 'iZooto' &&
      searchParams.get('utm_medium') === 'newswidget' &&
      searchParams.get('utm_campaign') === 'toi'
    ) {
      return searchParams.get('utm_source').toLocaleLowerCase();
    } else if (
      searchParams.get('utm_source') === 'affinity' &&
      searchParams.get('utm_medium') === 'dealnav' &&
      searchParams.get('utm_campaign') === 'toi'
    ) {
      return searchParams.get('utm_source').toLocaleLowerCase();
    }
    return searchParams.get('utm_term');
  }
  return keyword;
};

export const getURLSeparator = url => (url.includes('?') ? '&' : '?');

export const addIntermediatePageParams = (finalURL = '', params = []) => {
  let url = `${finalURL}${getURLSeparator(finalURL)}`;
  params.forEach((param = {}, index) => {
    const { key = '', value = '' } = param;
    url += `${key}=${value}${index < params.length - 1 ? '&' : ''}`;
  });
  return url;
};

export const getFinalURL = (
  intermediateURLConfig,
  url,
  isHotPicks,
  isPaidTraffic,
) => {
  const {
    utm_params: utmParams,
    tag,
    urlsuffix,
    intermediatePageParams = [],
  } = intermediateURLConfig;
  let finalURL = url;
  if (utmParams) {
    finalURL = `${url}${getURLSeparator(url)}${utmParams}`;
  } else if (tag) {
    const tempURL = new URL(finalURL);
    let tempTag = tag;
    if (isHotPicks) {
      if (isPaidTraffic) {
        tempTag = tag.replace(/hotpicks_/gi, 'hotpicks_pd_');
      } else if (isOrganicArticle()) {
        tempTag = tag.replace(/hotpicks_/gi, 'hotpicks_org_');
      }
    }
    tempURL.searchParams.set('tag', tempTag);
    finalURL = tempURL.toString();
  }
  finalURL = urlsuffix
    ? `${urlsuffix}${getURLSeparator(urlsuffix)}url=${encodeURIComponent(
        finalURL,
      )}`
    : finalURL;

  if (intermediatePageParams.length > 0) {
    finalURL = addIntermediatePageParams(finalURL, intermediatePageParams);
  }
  return finalURL;
};

export const getOnClickWindowFuntion = (functionName = '', parameters = []) => {
  if (typeof window !== 'undefined' && functionName && window[functionName]) {
    return { functionName, parameters };
  }
  return null;
};

export const getReviewsPageURLFromMspPageURL = pathname => {
  // "/most-searched-products/electronics/laptops/laptops-under-35000-affordable-options-for-all-your-work-needs/articleshow/87254741.cms"
  const [firstPart = '', urlSuffix] = pathname.split('/articleshow/');
  const urlChunks = firstPart.split('/');
  const sectionName = urlChunks[2];
  const title = urlChunks[urlChunks.length - 1];
  const domain = __PROD__ ? REVIEWS_LIVE_DOMAIN : REVIEWS_STAG_DOMAIN;
  if (sectionName === title) {
    return `${domain}/${title}/articleshow/${urlSuffix}`;
  }
  return `${domain}/${sectionName}/${title}/articleshow/${urlSuffix}`;
};
